module.exports = __webpack_public_path__ + "static/img/banner.8634f69.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/companyprofilepic/banner.jpg
// module id = CxsO
// module chunks = 51